import { render } from "./RestorantDetails.vue?vue&type=template&id=d7aa41a2&scoped=true&ts=true"
import script from "./RestorantDetails.vue?vue&type=script&lang=ts"
export * from "./RestorantDetails.vue?vue&type=script&lang=ts"

import "./RestorantDetails.vue?vue&type=style&index=0&id=d7aa41a2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7aa41a2"]])

export default __exports__